import { Stack } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';

import { getCommitteeProofsByOwnerOptions } from '@/module/Author/Committee/Proof';

import { ProofCard } from '@feature/proof';
import { Id } from '@feature/utils';

interface CommitteeOwnerProofListProps {
  committeeId: Id;
  userId: Id;
}

export function CommitteeOwnerProofList({ committeeId, userId }: CommitteeOwnerProofListProps) {
  const { data: proofs } = useSuspenseQuery(getCommitteeProofsByOwnerOptions(committeeId, userId));

  return (
    <Stack gap="xs">
      {proofs.map(proof => (
        <ProofCard
          key={proof.id}
          proof={proof}
          entity="committee"
          canEdit={false}
          isPending={false}
        />
      ))}
    </Stack>
  );
}
